export default __webpack_public_path__ + "static/media/accountBanner.f44fba46.png";